import { render, staticRenderFns } from "./UpdateRegistration.vue?vue&type=template&id=a030d40c"
import script from "./UpdateRegistration.vue?vue&type=script&lang=js"
export * from "./UpdateRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports